// src/components/Hero.js
import React, { useEffect, useRef, useState } from 'react';
import { Container, Button } from 'react-bootstrap';
import heroImage from '../assets/images/hero.jpg';
import './Hero.css';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import TaglineCarousel from './TaglineCarousel';
import Countdown from 'react-countdown';
import logoRooster from '../assets/images/logo-rooster.png';

const launchDate = new Date('2025-06-01T00:00:00');

const Hero = () => {
  const [isWithinCountdown, setIsWithinCountdown] = useState(false);

  useEffect(() => {
    const now = new Date();
    const diff = launchDate - now;
    const sevenDays = 30 * 24 * 60 * 60 * 1000;
    setIsWithinCountdown(diff <= sevenDays && diff > 0);

  }, []);

  return (
    <div
      className="hero-section position-relative"
      style={{
        backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.6)), url(${heroImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "100vh",
        overflow: "hidden",
      }}
      data-aos="fade-in"
    >
      <div className="hero-overlay position-absolute top-0 start-0 w-100 h-100"></div>

      <Container className="position-relative text-center text-white py-5">
        <motion.div
          initial="hidden"
          animate="visible"
          variants={{
            hidden: {},
            visible: {
              transition: { staggerChildren: 0.2 },
            },
          }}
        >
          {/* Launch Banner */}
          <motion.div
            className="mb-4 py-3 px-4 rounded-4 bg-light text-dark fw-semibold shadow mx-auto d-inline-block"
            style={{
              fontSize: "1.25rem",
              border: "1px solid #ccc",
              maxWidth: "600px",
              cursor: "pointer",
            }}
            initial={{ y: -50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ type: "spring", stiffness: 100, delay: 0.3 }}
          >
            <div className="d-flex justify-content-center align-items-center gap-2">
              <img src={logoRooster} alt="Rooster Logo" height="32" />
              <span>RxRooster Pilot Launch: <strong>June 1st</strong></span>
            </div>
            <div className="mt-1" style={{ fontSize: "0.95rem", color: '#555' }}>
              {isWithinCountdown ? (
                <Countdown
                  date={launchDate}
                  daysInHours={false}
                  renderer={({ days, hours, minutes, seconds }) => (
                    <span>
                      ⏳ <strong>{days}d {hours}h {minutes}m {seconds}s</strong> to go
                    </span>
                  )}
                />
              ) : (
                <>Built for CRNAs. Backed by facilities.</>
              )}
            </div>
          </motion.div>

          <TaglineCarousel />

          <motion.p
            className="lead mb-4 fs-4"
            variants={{ hidden: { opacity: 0, y: 20 }, visible: { opacity: 1, y: 0 } }}
          >
            RxRooster connects CRNAs directly with facilities — no agencies, no markups, just transparent staffing.
            <br className="d-none d-md-block" />
            <strong className="fw-semibold">Join the platform built for you. Not them.</strong>
          </motion.p>

          <motion.div
            className="d-flex flex-wrap justify-content-center mt-4 gap-3"
            variants={{ hidden: { opacity: 0 }, visible: { opacity: 1 } }}
          >
            <Button
              as={Link}
              to="/register"
              variant="primary"
              className="btn-lg rounded-pill px-5 text-uppercase fw-bold shadow-lg hover-scale"
            >
              Join Now
            </Button>
            <Button
              as={Link}
              to="/login"
              variant="outline-light"
              className="btn-lg rounded-pill px-5 text-uppercase fw-bold shadow btn-glass"
            >
              Log In
            </Button>
          </motion.div>
        </motion.div>
      </Container>
    </div>
  );
};

export default Hero;
